import { API_BASE_URL } from "@constants/urls";
import authAxios from "@helpers/lib/axios";
import type { MixedItemDistAction } from "@hooks/types";
import type { MixedItemDist } from "@memorang/types/src/tag";

interface MixedItemDistributionRequest {
	userPublicMetadataId: number;
	examId: string;
	action: MixedItemDistAction;
	collectionId?: number;
}
export async function getMixedItemDistribution(
	request: MixedItemDistributionRequest,
): Promise<MixedItemDist> {
	// if (isMocked) {
	// 	return mockedMixedItemDistribution;
	// }
	const params = new URLSearchParams({
		examId: request.examId,
		action: request.action || "",
	});

	if (request.collectionId) {
		params.append("collectionId", request.collectionId.toString());
	}

	const { data } = await authAxios.get(
		`${API_BASE_URL}/assessments/v1/users/${request.userPublicMetadataId}/item-distribution?${params.toString()}`,
	);

	return data.data;
}
